


export type AppHeaderStateType = {
    refreshActionEnabled: boolean;
    exportExcelEnabled: boolean;
    exportPDFEnabled: boolean;
    favoriteActionEnabled: boolean;
    saveGraphImageEnabled: boolean;
    saveQuickGraphEnabled: boolean;
}

export type AppHeaderExportParams = {
    exportExcelEnabled: boolean;
    exportPDFEnabled: boolean;
    saveGraphImageEnabled: boolean;
    saveQuickGraphEnabled: boolean;
}

export type AppHeaderContextType = {
    appHeaderContextState: AppHeaderStateType;
    setRefreshActionState: (value: boolean) => void;
    setExportActionState: (value: AppHeaderExportParams) => void;
    setFavoriteActionState: (value: boolean) => void;
}

export enum AppHeaderContextActionType {
    RefreshStateChanged = 'APPHEADER_REFRESH_STATE_CHANGED',
    ExportStateChanged = 'APPHEADER_EXPORT_STATE_CHANGED',    
    FavoriteStateChanged = 'APPHEADER_FAVORITE_STATE_CHANGED',
    ResetChanged = 'APPHEADER_CONTEXT_RESET'
}

export type AppHeaderContextAction = {
    type: AppHeaderContextActionType.RefreshStateChanged;
    payload: boolean;
} | {
    type: AppHeaderContextActionType.ExportStateChanged;
    payload: AppHeaderExportParams;
} | {
    type: AppHeaderContextActionType.FavoriteStateChanged;
    payload: boolean;
} | {
    type: AppHeaderContextActionType.ResetChanged;
    payload: void;
};
